import React, { createContext, useContext, useState } from 'react';

// Create the context
const HeadersContext = createContext();

// Create a custom hook for convenience
export const useHeaders = () => {
  return useContext(HeadersContext);
};

// Provider component
export const HeadersProvider = ({ children }) => {
  const [headers, setHeaders] = useState(null);

  return (
    <HeadersContext.Provider value={{ headers, setHeaders }}>
      {children}
    </HeadersContext.Provider>
  );
};
